import { css } from "emotion";

export const ButtonStyle = css`
  display: inline-block;
`;
